import React from "react";

export const adminInput = "w-full bg-black/30 border border-white/10 rounded-md px-3 py-2 text-sm text-foreground focus:border-pool focus:outline-none focus:ring-1 focus:ring-pool/40";

export function Panel({ title, action, children, className = "" }) {
  return (
    <div className={`bg-surface/60 border border-white/10 rounded-lg ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          {title && <h3 className="text-sm font-medium tracking-label uppercase text-foreground/80">{title}</h3>}
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export function Stat({ label, value, accent = "gold", onClick, testid }) {
  const color = accent === "pool" ? "text-pool" : accent === "red" ? "text-red-300" : "text-gold";
  return (
    <button
      onClick={onClick}
      disabled={!onClick}
      data-testid={testid}
      aria-label={onClick ? `Open ${label}` : label}
      className={`group text-left bg-surface/60 border border-white/10 rounded-lg p-5 transition-all outline-none ${onClick ? "cursor-pointer hover:border-pool/50 hover:bg-surface/80 focus-visible:ring-2 focus-visible:ring-pool/60 focus-visible:border-pool/60" : "cursor-default"}`}>
      <p className="text-[11px] tracking-label uppercase text-muted-foreground flex items-center justify-between">
        {label}
        {onClick && <span className="text-pool opacity-0 group-hover:opacity-100 transition-opacity text-sm" aria-hidden>→</span>}
      </p>
      <p className={`font-serif text-4xl mt-2 ${color}`}>{value}</p>
    </button>
  );
}

export function Th({ children, className = "" }) {
  return <th className={`text-left text-[10px] tracking-label uppercase text-muted-foreground font-medium px-3 py-2.5 ${className}`}>{children}</th>;
}
export function Td({ children, className = "" }) {
  return <td className={`px-3 py-3 text-sm border-t border-white/5 ${className}`}>{children}</td>;
}

export function AdminHeading({ title, subtitle, children }) {
  return (
    <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
      <div>
        <h1 className="font-serif text-3xl">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
